import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import getUserInfo from "../shared/core/GetTokenized";

const Route = require("react-router-dom").Route;
const Switch = require("react-router-dom").Switch;
const Router = require("react-router-dom").BrowserRouter;

const Redirect = require("react-router-dom").Redirect;
const PrivateRoute = () => {
    const information =  getUserInfo(); // Get the user info (will resolve the promise)
    const PatienInformation = JSON.parse(information);
    const location = useLocation()
 
    // const  getAyncUser = true;
    if (!PatienInformation && location.pathname !== "/login") {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
 
    // Render the child components if the user is authenticated
    return <Outlet />;
 
}

// const PrivateRoute = ({ component: Component, authed, ...rest }) => {

//     // return (
//     //     <Route {...rest} render={props => (
//     //         isAuthenticated ? (<Component {...props} />
//     //         ) : (
//     //                 <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
//     //             )
//     //     )} />
//     // )

//     return (
//         <Route
//             {...rest}
//             render={(props) => authed === true
//                 ? <Component {...props} />
//                 : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />}
//         />
//     )

// }

export default PrivateRoute